"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationIntl = void 0;
var react_intl_1 = require("react-intl");
var locale_1 = require("./utils/locale");
var numeral = require("numeral");
var moment = require("moment-timezone");
var dateFormat_1 = require("./constants/dateFormat");
var timeZone_1 = require("./utils/timeZone");
var numberFormat_1 = require("./constants/numberFormat");
var environment_1 = require("./constants/environment");
var TranslationIntl = function () {
  function TranslationIntl(config) {
    this.locale = config.locale;
    this.intl = react_intl_1.createIntl(__assign(__assign({}, config), {
      locale: locale_1.convertGrLocaleToBcpLocale(config.locale),
      formats: {
        number: numberFormat_1.reactIntlNumberFormats
      }
    }), react_intl_1.createIntlCache());
    this.defaultTimeZone = timeZone_1.getTimeZoneNameById(config.defaultTimeZoneId);
  }
  TranslationIntl.prototype.translate = function (id, values) {
    if (values === void 0) {
      values = {};
    }
    if (!id) {
      if (environment_1.isDevelopment) {
        console.warn('Empty translation key');
      }
      return 'Invalid translation';
    }
    return this.intl.formatMessage({
      id: id
    }, values);
  };
  TranslationIntl.prototype.formatCurrency = function (value, currency, minimumFractionDigits) {
    if (minimumFractionDigits === void 0) {
      minimumFractionDigits = 2;
    }
    var ten = 10;
    var multiplier = Math.pow(ten, minimumFractionDigits);
    var currencyValue = Math.round(parseFloat(value.toString()) * multiplier) / multiplier;
    return this.intl.formatNumber(currencyValue, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: minimumFractionDigits
    });
  };
  TranslationIntl.prototype.formatNumber = function (value, options) {
    if (options === void 0) {
      options = {};
    }
    var _short = options["short"],
      otherOptions = __rest(options, ["short"]);
    if (_short) {
      numeral.locale(locale_1.convertGrLocaleForNumeral(this.locale));
      return numeral(value).format(options.format);
    } else {
      return this.intl.formatNumber(value, otherOptions);
    }
  };
  TranslationIntl.prototype.formatDate = function (value, options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.format,
      format = _a === void 0 ? dateFormat_1.DateFormat.FULL_DATE_WITH_TIME_SHORT : _a;
    return this.catchTheMoment(value, options).format(format).replace('AM', 'am').replace('PM', 'pm');
  };
  TranslationIntl.prototype.catchTheMoment = function (value, options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.preserveTimeZone,
      preserveTimeZone = _a === void 0 ? false : _a,
      _b = options.timestamp,
      timestamp = _b === void 0 ? false : _b,
      _c = options.timeZone,
      timeZone = _c === void 0 ? this.defaultTimeZone : _c;
    var parsedDate;
    if (timestamp) {
      parsedDate = moment(parseInt(value, 10));
    } else if (preserveTimeZone) {
      parsedDate = moment.parseZone(value);
    } else {
      parsedDate = moment(value);
    }
    parsedDate.locale(this.intl.locale);
    var convertedDate = parsedDate;
    if (!preserveTimeZone) {
      convertedDate = moment.tz(parsedDate, timeZone);
    }
    return convertedDate;
  };
  TranslationIntl.prototype.getIntlObject = function () {
    return this.intl;
  };
  return TranslationIntl;
}();
exports.TranslationIntl = TranslationIntl;